export const modalTypes = {
  SEAT_MAP_PERSIST_IN_PRODUCT_UNBOOKED_SEGMENTS: 'SEAT_MAP_PERSIST_IN_PRODUCT_UNBOOKED_SEGMENTS',
  SEAT_MAP_PERSIST_IN_PRODUCT: 'SEAT_MAP_PERSIST_IN_PRODUCT'
};
export const modalActionTypes = {
  SEAT_MAP_PERSIST_ACTION_ACCEPT: 'SEAT_MAP_PERSIST_ACTION_ACCEPT',
  SEAT_MAP_PERSIST_ACTION_DISMISS: 'SEAT_MAP_PERSIST_ACTION_DISMISS'
};
export const modalRedirectDestinations = {
  DEFAULT: 'DEFAULT',
  PAYMENT: 'PAYMENT',
  SUMMARY: 'SUMMARY'
};
export const SEAT_MAP_DIALOG_ID = 'seat-map-dialog';
export const SEAT_MAP_UNBOOKED_SEGMENTS_DIALOG_ID = 'seatMap-persist-modal-SEAT_MAP_PERSIST_IN_PRODUCT_UNBOOKED_SEGMENTS';
export const SEAT_MAP_PERSIST_DIALOG_ID = 'seatMap-persist-modal-SEAT_MAP_PERSIST_IN_PRODUCT';
export const SEAT_MAP_CARD_MAX_WIDTH = 568;
export const STEP_INDICATOR_HEIGHT = 48;
//# sourceMappingURL=modal.js.map